module.exports = __webpack_public_path__ + "static/media/play-store-badge.a240fc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/play-store-badge.png
// module id = 273
// module chunks = 0